const accent = {
    A00: '#FD8888',
    A01: '#0E253A',
    A02: '#194166',
    A03: '#FD8888',
};

export default accent;
